exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-marker-transition {\n  transition: all 1s ease; /* Adjust the duration and timing function as needed */\n}", ""]);

// exports
